import { useTranslation } from 'react-i18next';

export function TotpInput({ otp, saveOtp, err }) {
  let { t } = useTranslation();

  return (
    <div>
      {t('instructions_2fa_2')}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {err && <span style={{ color: 'red' }}>{t('otp_invalid')}</span>}
          <input
            type="number"
            value={otp}
            onChange={saveOtp}
            style={{ fontSize: '2rem', fontWeight: 'bold', padding: '1rem', width: '12rem' }}
            max="999999"
          />
        </div>
      </div>
    </div>
  );
}
